export const locales = {
	organism: 'Sécurité sociale',
	assuranceMaladie: 'l’Assurance Maladie',
	signature: 'Agir ensemble, protéger chacun',
	risquePro: 'Risques Professionnels'
};
